import { NextPage } from 'next'
import React from 'react'
import styled from 'styled-components'

const StyledIframe = styled.iframe`
  width: 100vw;
  height: 100vh;
  border: 0;
`

const Toc: NextPage = () => {
  return <StyledIframe src="/tos.html" frameBorder={0} />
}

export default Toc
